<script>
    import { createEventDispatcher } from "svelte";

    let dispatch = createEventDispatcher();
    export let title;
    export let dense = false;
    export let paragraphPadding = false;
    export let bigImage = false;
</script>

<div class="container" on:click={() => dispatch("click")}>
    <div class="headline-xs main-headline" style={bigImage ? "flex: 1.3;" : ""}>
        {#if title}
            {title}
        {/if}
        <slot name="title" />
    </div>
    <div class="content" class:dense class:paragraphPadding>
        <slot name="content" />
    </div>
</div>

<style>
    .content {
        padding: 16px 0;
        margin-bottom: 16px;
        display: inline-block;
        width: -webkit-fill-available;
    }

    .dense {
        padding: 0;
        margin-bottom: 0;
    }

    .container {
        width: 100%;
    }

    @media only screen and (min-width: 1440px) {
        .container {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
        }

        .content {
            flex: 2.5;
            padding-top: 0;
            width: -webkit-fill-available;
        }

        .main-headline {
            flex: 1;
            font-weight: 700;
            font-size: 24px;
            line-height: 100%;
            margin-top: 0;
            margin-right: 32px;
        }

        .paragraphPadding {
            margin-top: -20px;
        }
    }
</style>
